import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

export const BRAND = 'rgb(24, 20, 54)';
export const ORANGE = '#ff7a28';

export const toTitleCase = (str) =>
  str ? str.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '—';

export const avatarColor = (str = '') => {
  const palette = ['#5e35b1', '#1565c0', '#00695c', '#ad1457', '#6d4c41', '#37474f'];
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return palette[Math.abs(hash) % palette.length];
};

export const buildInitialStatuses = (drivers) =>
  Object.fromEntries((drivers || []).map((d, i) => [d._id || i, Boolean(d.status)]));

export const sectionMeta = [{ id: '1', title: 'Driver List', Icon: LocalShippingOutlinedIcon }];
